import React, { memo } from "react";
import { Container, Row, Col } from "reactstrap";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import styles from "../../styles/public/reserve-page.module.css";

const Features = memo(({ organization, features }) => {
    return (
        <>
            {
                organization && organization.feature_text && (
                    <div className={styles["section-subtitle"]}>
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>{organization.feature_text}</ReactMarkdown>
                    </div>
                )   
            }
            <Container className={styles["features-grid"]}>
                <Row className={styles["features-row"]}>
                    {features.map((feature, index) => (
                        <Col key={index} md={4} className="d-flex align-items-stretch">
                            <div className={styles["features-card"]}>
                                <div className={styles.icon}>
                                    <img src={feature.icon} alt={feature.title} className="img-fluid" />
                                </div>
                                <div className={styles["feature-title"]}>{feature.title}</div>
                                <ReactMarkdown remarkPlugins={[remarkGfm]}>{feature.description}</ReactMarkdown>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </>
    );
});

export default Features;
